import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";

const services = [
  {
    n: "01",
    title: "Nettoyage & désinfection de climatisation",
    text: "Nettoyage des filtres et des unités, désinfection complète de votre climatisation existante. Un air sain et un appareil qui dure plus longtemps — entretien uniquement : pas de pose, ni de recharge de fluide (gaz).",
  },
  {
    n: "02",
    title: "Nettoyage de panneaux solaires",
    text: "Nettoyage soigneux et sécurisé de vos panneaux existants pour retrouver tout leur rendement — nettoyage uniquement, pas d'installation.",
  },
  {
    n: "03",
    title: "Nettoyage de gouttières",
    text: "Débouchage et nettoyage de vos gouttières pour un écoulement parfait et une toiture protégée toute l'année.",
  },
  {
    n: "04",
    title: "Ramonage",
    text: "Ramonage de vos conduits de cheminée et poêle, avec certificat pour votre assurance. Votre sécurité, sans compromis.",
  },
  {
    n: "05",
    title: "Tous travaux",
    text: "Petites réparations et aménagements : une seule personne de confiance pour tout ce qui touche à l'entretien de votre maison.",
  },
];

export const Services = () => {
  const [open, setOpen] = useState(null);

  return (
    <section
      id="services"
      className="px-6 md:px-12 py-32 md:py-48 border-t border-white/10"
      data-testid="services-section"
    >
      <motion.p
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9 }}
        className="text-xs uppercase tracking-[0.3em] text-gold mb-20"
        data-testid="services-overline"
      >
        Services
      </motion.p>

      <div>
        {services.map((s, i) => (
          <motion.div
            key={s.n}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, delay: i * 0.08 }}
            className="border-b border-white/10 first:border-t"
            data-testid={`service-item-${s.n}`}
          >
            <button
              onClick={() => setOpen(open === i ? null : i)}
              data-testid={`service-toggle-${s.n}`}
              className="w-full flex items-center justify-between py-8 md:py-10 text-left group"
            >
              <div className="flex items-baseline gap-6 md:gap-12">
                <span className="text-xs text-gold tracking-[0.2em]">{s.n}</span>
                <span className="font-serif text-3xl md:text-5xl tracking-tight group-hover:translate-x-3 transition-transform duration-700 ease-out">
                  {s.title}
                </span>
              </div>
              <Plus
                className={`w-5 h-5 text-ash shrink-0 transition-transform duration-500 ${
                  open === i ? "rotate-45 text-gold" : ""
                }`}
              />
            </button>
            <AnimatePresence initial={false}>
              {open === i && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.6, ease: [0.76, 0, 0.24, 1] }}
                  className="overflow-hidden"
                >
                  <p
                    className="text-sm md:text-base text-ash font-light leading-relaxed max-w-xl pb-10 md:pl-24"
                    data-testid={`service-text-${s.n}`}
                  >
                    {s.text}
                  </p>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
